import { memo } from 'react';
import { AccessoryDetailProps } from '../../models';

const DamperDetails = ({ accessory }: AccessoryDetailProps) => {
  return (
    <div className="bot-accessories__detail-card">
      <div className="bot-accessories__detail-title">Damper</div>
      <p className="bot-accessories__detail-description">
        Dampers default to the section&apos;s mount location until configured.
      </p>
      <div className="bot-accessories__detail-grid">
        <div>
          <span className="bot-accessories__detail-label">Mount</span>
          <span className="bot-accessories__detail-value">
          </span>
        </div>
        <div>
          <span className="bot-accessories__detail-label">Name</span>
          <span className="bot-accessories__detail-value">{accessory.name}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(DamperDetails);

